"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LastLocationButton = void 0;
var _hooks = require("../../../../../../../hooks");
var _Book = require("../../../../Book.labels");
var _Button = require("../../../../../../../UI/Button");
var _LastLocationButton = require("./LastLocationButton.styles");
var _Icon = require("../../../../../../../UI/Icon");
var _jsxRuntime = require("react/jsx-runtime");
const LastLocationButton = props => {
  const {
    optionalData,
    view = 'default',
    currentPageUrl
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const styles = (0, _LastLocationButton.useStyles)(props);
  const getLabel = (0, _hooks.useLabels)({
    labels: _Book.labels
  });
  const handleLastLocationClick = event => {
    event.preventDefault();
    event.stopPropagation();
    if (isMobileView || view === 'horizontal') {
      window.open(currentPageUrl);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
    id: "ccLastLocationButton",
    size: view === 'horizontal' ? 'stretch' : 'x-small',
    shape: view === 'horizontal' ? 'rectangle' : 'ellipse',
    onClick: handleLastLocationClick,
    category: "bookTile",
    label: "lastPageLink",
    optionalData: optionalData,
    color: "primary",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Book__last-location-button__content'],
      children: [getLabel('preview_book_open_last_page'), view === 'horizontal' && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-Book__last-location-button__arrow'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          name: "Caret",
          width: 16,
          height: 16
        })
      })]
    })
  });
};
exports.LastLocationButton = LastLocationButton;